export const GET_GEOSPHEREDATAPLATFORM_DATA = 'GET_GEOSPHEREDATAPLATFORM_DATA';
export const FILTER_ITEMS = 'FILTER_ITEMS';
export const RESET = 'RESET';
export const CHART_COMPONENT = 'CHART_COMPONENT';
export const SET_LANGUAGE = 'SET_LANGUAGE';
